import { Badge } from '@mantine/core';
import { IconAlarm } from '@tabler/icons-react';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import { AssetDetailsDtoCurrentUserRoleEnum } from 'src/Services/API/generated';

import { Props } from './MemberRoleBadge.types';

// t('admin.members.roleType.owner', "Administrateur")
// t('admin.members.roleType.manager', "Gestionnaire")
// t('admin.members.roleType.member', "Membre")
// t('admin.members.roleType.viewer', "Visiteur")
// t('admin.members.roleType.pendingInvitation', "Invitation en attente")

const roleToColor: Record<
  AssetDetailsDtoCurrentUserRoleEnum | 'pendingInvitation',
  { background: string; text: string }
> = {
  [AssetDetailsDtoCurrentUserRoleEnum.Manager]: { background: '#03C3EC14', text: '#03C3EC' },
  [AssetDetailsDtoCurrentUserRoleEnum.Member]: { background: '#F4F7F7', text: '#4B696F' },
  [AssetDetailsDtoCurrentUserRoleEnum.Viewer]: { background: '#F4F7F7', text: '#6ab781' },
  pendingInvitation: { background: '#F4F7F7', text: 'rgba(75,105,111,0.6)' },
};

const MemberRoleBadge = forwardRef<HTMLDivElement, Props>(function MemberRoleBadge(
  { role, ...rest },
  ref
) {
  const { t } = useTranslation();

  return (
    <Badge
      ref={ref}
      color={roleToColor[role as keyof typeof roleToColor]?.background}
      styles={{ label: { color: roleToColor[role as keyof typeof roleToColor]?.text } }}
      leftSection={
        role === 'pendingInvitation' && (
          <IconAlarm height={16} color={roleToColor[role as keyof typeof roleToColor]?.text} />
        )
      }
      {...rest}
    >
      {t(`admin.members.roleType.${role}`)}
    </Badge>
  );
});

export default MemberRoleBadge;
